<script>
  /**
   * @overview 复制或移动
   *
   * @author retro
   */
  import mapUtils, { $http, $token, $form, $list } from "@/utils";

  export default {
    name: "CopyOrMove",

    props: {
      visible: {
        type: Boolean,
        default: false,
      },

      data: {
        type: [Object, Array],
        default: null,
      },

      // 类型为copy复制 或 move移动
      type: {
        type: String,
        default: 'copy',
      },
    },

    data: () => ({
      loading: false,
      formData: {
        select: '',
      },
      rules: {
        select: [{ required: true, message: '请选择' }],
      },
    }),
    methods: {
      submit() {
        this.$refs.form.validate((res) => {
          if (res) {
            this.$emit('success', this.formData.select, this.type);
            this.cancel();
          }
        });
      },
      cancel() {
        this.$emit("update:visible", false);
        setTimeout(() => {
          this.formData.select = '';
          }, 200);
        setTimeout(() => {
          this.$refs.form.clearValidate();
          }, 500);
      },
      // 默认选中值
      selected(id) {
        this.formData.select = id;
      },
    },
  };
</script>

<template>
  <el-dialog
    :show-close="false"
    :visible="visible"
    width="550px"
    class="course-list-editor"
  >
    <div slot="title">
      请选择需{{ type==='copy'?'复制':'移动' }}的目录下
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
    >
      <el-form-item
        label="目录"
        prop="select"
      >
        <el-select
          v-model="formData.select">
          <el-option
            v-for="item in data"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <AppFormSubmit
      slot="footer"
      :submitting="loading"
      @submit="submit"
      @cancel="cancel"
    />
  </el-dialog>
</template>

<style lang="postcss" scoped>
</style>
